<template>
  <div class="gift-list gift-list--valid">
    <scroller
      lock-x scrollbar-y
      v-if="list.length > 0">
      <div>
        <div :key="item.card_no" v-for="item in list" class="gift-list__item gift-card">
          <gift-card :cardData="item"></gift-card>
        </div>
        <div class="gift-list__blank"></div>
      </div>
    </scroller>

    <div class="gift-list__empty" v-if="list.length === 0 && completed">
      <no-car title="暂无礼品卡"></no-car>
    </div>
  </div>
</template>

<script>
import {
  Scroller
} from '@lx-frontend/cvux'
import NoCar from '../components/NoCar'
import GiftCard from './GiftCard'

export default {
  data() {
    return {
      params: {
        owner_id: this.$route.query._owner_id || '',
        sender_id: this.$route.query._sender_id || '',
        store_id: this.$route.query._from_store_id || ''
      },
      list: [],
      completed: false
    }
  },
  created() {
    this.getGiftList()
  },
  components: {
    Scroller,
    NoCar,
    GiftCard
  },
  methods: {
    async getGiftList() {
      const queryParams = { ...this.params }
      this.completed = false
      const {
        code,
        message,
        data = []
      } = await this.$rest.gift.getValidGiftList(queryParams)

      if (code !== 0) {
        this.showToast(message)
        this.completed = true
        return
      }

      const formatList = data.map((item) => {
        return {
          is_canceled: false,
          face_value: item.amount,
          create_at: item.start_time,
          effective_at: item.start_time,
          expired_at: item.end_time,
          ...item
        }
      })

      this.list = formatList
      this.completed = true
    }
  }
}
</script>

<style scoped lang="less">
@import '../../stylesheets/base/fn';
.gift-card {
  margin: 15 / @w;
}
.gift-list__blank {
  height: 30 / @w;
}
</style>
